document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.logotypes');
    if (!section) return;

    const button = section.querySelector('.logotypes__show-more');
    const list = section.querySelector('.logotype');
    if (!button || !list) return;

    const originalText = button.innerHTML;
    const showLessText = button.getAttribute('data-js-show-less');
    const chevronIcon = button.querySelector('svg')?.outerHTML || '';

    // Initialize aria-expanded
    button.setAttribute('aria-expanded', 'false');

    button.addEventListener('click', () => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        const nextState = !isExpanded;
        
        button.setAttribute('aria-expanded', nextState);

        const currentChevron = button.querySelector('svg')?.outerHTML || chevronIcon;

        if (nextState) {
            button.innerHTML = `${currentChevron} ${showLessText} ${currentChevron}`;
            
            // Wait for the next frame to ensure aria-expanded has applied and layout is updating
            requestAnimationFrame(() => {
                const firstItem = list.querySelector('.logotype__item');
                if (firstItem) {
                    const scrollAmount = firstItem.offsetHeight * 4;
                    window.scrollBy({
                        top: scrollAmount,
                        behavior: 'smooth'
                    });
                }
            });
        } else {
            const firstItem = list.querySelector('.logotype__item');
            const header = document.querySelector('.header');
            let targetY = 0;
            
            if (firstItem) {
                const rect = firstItem.getBoundingClientRect();
                const headerHeight = header ? header.offsetHeight : 0;
                targetY = rect.top + window.pageYOffset - headerHeight - 20;
            }

            button.innerHTML = originalText;
            
            // Apply a small delay to allow the layout engine to start the collapse 
            // but ensure we scroll to the position we captured BEFORE collapse.
            if (firstItem && window.pageYOffset > targetY) {
                requestAnimationFrame(() => {
                    window.scrollTo({
                        top: targetY,
                        behavior: 'smooth'
                    });
                });
            }
        }
    });
});
